var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAirimpactLogoColorfulWithText = function SvgAirimpactLogoColorfulWithText(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 30,
    viewBox: "0 0 142 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9445_111112)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9445_111112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_9445_111112)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.1388,
    cy: 26.5802,
    r: 10.4788,
    transform: "rotate(20.8436 21.1388 26.5802)",
    fill: "url(#paint1_linear_9445_111112)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5299,
    cy: 3.60571,
    r: 10.9143,
    fill: "#C0D9BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5292 14.5207C16.557 14.5207 21.4435 9.63415 21.4435 3.60635C21.4435 2.83517 21.3636 2.08268 21.2114 1.35671C20.1976 1.10128 19.13 0.964844 18.0275 0.964844C11.4156 0.964844 6.05554 5.87233 6.05554 11.926C6.05554 12.5049 6.10455 13.0733 6.19898 13.6279C7.52653 14.2023 8.99071 14.5207 10.5292 14.5207Z",
    fill: "url(#paint2_linear_9445_111112)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9445_111112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36195 24.0264C-0.272232 23.8439 -3.56708 25.523 -4.69183 26.2935L-10.1902 21.2496C-7.83965 20.6024 -2.81154 19.1341 -1.50342 18.4392C-0.195294 17.7442 2.66963 15.2881 3.93858 14.1469L12.6253 6.431C12.6253 6.431 14.008 5.08004 14.6948 5.61258C15.3257 6.1017 14.857 7.12183 14.3909 7.88741C13.3917 9.52897 11.754 11.2433 11.754 11.2433C10.5363 12.7705 8.63297 15.0298 8.63297 15.0298C7.48764 16.6687 7.42321 18.2803 7.97183 19.1681C8.76458 20.4511 9.78386 19.987 11.331 20.4511C12.6882 20.8583 13.2857 21.3628 13.7181 21.8386C14.1505 22.3145 14.3496 22.8428 14.022 23.3653C13.5494 24.119 12.0809 23.5474 12.0809 23.5474C10.7664 23.3463 10.1574 22.8372 7.97183 23.2887C5.1523 23.8711 5.52125 24.4912 1.36195 24.0264Z",
    fill: "#F5FFF1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9445_111112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6385 24.0264C30.2727 23.8439 33.5676 25.523 34.6923 26.2935L40.1907 21.2496C37.8401 20.6024 32.812 19.1341 31.5039 18.4392C30.1958 17.7442 27.3309 15.2881 26.0619 14.1469L17.3751 6.431C17.3751 6.431 15.9925 5.08004 15.3056 5.61258C14.6748 6.1017 15.1435 7.12183 15.6095 7.88741C16.6088 9.52897 18.2465 11.2433 18.2465 11.2433C19.4642 12.7705 21.3675 15.0298 21.3675 15.0298C22.5128 16.6687 22.5773 18.2803 22.0287 19.1681C21.2359 20.4511 20.2166 19.987 18.6695 20.4511C17.3123 20.8583 16.7148 21.3628 16.2824 21.8386C15.85 22.3145 15.6508 22.8428 15.9785 23.3653C16.451 24.119 17.9196 23.5474 17.9196 23.5474C19.2341 23.3463 19.8431 22.8372 22.0287 23.2887C24.8482 23.8711 24.4792 24.4912 28.6385 24.0264Z",
    fill: "#F5FFF1"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.581 21.856C135.243 21.856 133.087 19.7974 133.087 14.9584V4.21094H135.716V8.22119H139.581V10.6006H135.716V14.6109C135.716 18.2468 137.162 19.3964 139.581 19.3964V21.856Z",
    fill: "#244242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.929 14.9042C120.929 10.9474 123.585 7.95312 127.686 7.95312C129.422 7.95312 130.631 8.48783 131.578 9.18294V12.1773C130.71 11.0544 129.527 10.4127 127.923 10.4127C125.425 10.4127 123.664 12.3644 123.664 14.9042C123.664 17.4441 125.425 19.3957 127.923 19.3957C129.527 19.3957 130.71 18.8877 131.578 17.7649V20.7592C130.631 21.481 129.422 21.8553 127.686 21.8553C123.585 21.8553 120.929 18.861 120.929 14.9042Z",
    fill: "#244242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.956 21.8553C109.354 21.8553 106.961 18.7541 106.961 14.9042C106.961 11.0544 109.354 7.95312 112.956 7.95312C114.744 7.95312 116.058 8.72844 116.926 9.95825V8.22048H119.45V21.588H116.926V19.8502C116.058 21.08 114.744 21.8553 112.956 21.8553ZM109.564 14.9042C109.564 17.7114 111.142 19.5561 113.219 19.5561C115.217 19.5561 116.926 17.952 116.926 14.9042C116.926 11.9901 115.217 10.2523 113.219 10.2523C111.142 10.2523 109.564 12.0971 109.564 14.9042Z",
    fill: "#244242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9135 21.8553C98.2571 21.8553 96.9162 21.1602 95.9433 20.0373V26.026H93.3141V8.22048H95.9433V9.77111C96.9162 8.64824 98.2571 7.95312 99.9135 7.95312C103.621 7.95312 105.935 11.0544 105.935 14.9042C105.935 18.7541 103.621 21.8553 99.9135 21.8553ZM95.9433 14.9042C95.9433 17.6579 97.4946 19.5561 99.6506 19.5561C101.78 19.5561 103.305 17.5777 103.305 14.9042C103.305 12.2307 101.78 10.2523 99.6506 10.2523C97.4946 10.2523 95.9433 12.1505 95.9433 14.9042Z",
    fill: "#244242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2387 14.5834C80.2387 11.8297 79.3973 10.3058 77.6883 10.3058C75.7952 10.3058 74.4017 12.1773 74.4017 16.3747V21.588H71.7725V8.22048H74.4017V10.2523C75.4271 8.64824 76.9258 7.95312 78.3982 7.95312C80.3701 7.95312 81.7899 8.94232 82.421 10.9474C83.4201 8.86212 85.1554 7.95312 86.8907 7.95312C89.7303 7.95312 91.3867 10.0385 91.3867 14.1289V21.588H88.7312V14.5834C88.7312 11.8564 87.9424 10.3058 86.1808 10.3058C84.2877 10.3058 82.8942 12.1238 82.8942 16.3479V21.588H80.2387V14.5834Z",
    fill: "#244242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9238 21.5902V8.22266H69.5794V21.5902H66.9238Z",
    fill: "#244242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.598 21.588V8.22048H60.2273V11.295C61.0686 9.12947 63.1458 7.95312 65.5121 7.95312V10.5732C63.4613 10.5732 60.4113 11.696 60.2273 16.4816V21.588H57.598Z",
    fill: "#244242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7494 21.5902V8.22266H55.4049V21.5902H52.7494Z",
    fill: "#244242"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3223 21.8553C40.7203 21.8553 38.3276 18.7541 38.3276 14.9042C38.3276 11.0544 40.7203 7.95312 44.3223 7.95312C46.1102 7.95312 47.4249 8.72844 48.2925 9.95825V8.22048H50.8166V21.588H48.2925V19.8502C47.4249 21.08 46.1102 21.8553 44.3223 21.8553ZM40.9306 14.9042C40.9306 17.7114 42.5082 19.5561 44.5853 19.5561C46.5835 19.5561 48.2925 17.952 48.2925 14.9042C48.2925 11.9901 46.5835 10.2523 44.5853 10.2523C42.5082 10.2523 40.9306 12.0971 40.9306 14.9042Z",
    fill: "#244242"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5858 4.63454C68.4307 3.77537 70.076 4.0015 70.076 4.0015C70.076 4.0015 70.2984 5.67453 69.4535 6.53366C68.6086 7.39278 66.9632 7.1667 66.9632 7.1667C66.9632 7.1667 66.7409 5.49372 67.5858 4.63454Z",
    fill: "#244242"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4008 4.63454C54.2457 3.77537 55.8911 4.0015 55.8911 4.0015C55.8911 4.0015 56.1134 5.67453 55.2685 6.53366C54.4236 7.39278 52.7783 7.1667 52.7783 7.1667C52.7783 7.1667 52.5559 5.49372 53.4008 4.63454Z",
    fill: "#244242"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9445_111112",
    x: -10.1902,
    y: 4.30119,
    width: 25.883,
    height: 21.9918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.692471,
    dy: -1.18709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.692471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.506008 0 0 0 0 0.689569 0 0 0 0 0.61228 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9445_111112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9445_111112",
    x: 14.7033,
    y: 4.49904,
    width: 25.4873,
    height: 21.7939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.296773,
    dy: -0.989245
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.692471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.506008 0 0 0 0 0.689569 0 0 0 0 0.61228 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9445_111112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9445_111112",
    x1: 18.6847,
    y1: 30.0002,
    x2: 11.0692,
    y2: -8.02387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#234141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429045,
    stopColor: "#196675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995237,
    stopColor: "#5FB8C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9445_111112",
    x1: 21.2187,
    y1: 39.6666,
    x2: 16.4776,
    y2: 14.0502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.460928,
    stopColor: "#1C736B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EBFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9445_111112",
    x1: 8.02923,
    y1: 4.7763,
    x2: 24.5222,
    y2: 10.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18774F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18774F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9445_111112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9445_111112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAirimpactLogoColorfulWithText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "airimpact-logo-colorful-with-text.165cca6677af178539dcf69ed6b04db4.svg";